import type { RequestListQuery } from '@magimp/shared';

export function serializeFiltersToUrl(filters: Partial<RequestListQuery>): string {
  const params = new URLSearchParams();
  if (filters.status && filters.status.length > 0) {
    for (const s of filters.status) params.append('status', s);
  }
  if (filters.slaState && filters.slaState.length > 0) {
    for (const s of filters.slaState) params.append('slaState', s);
  }
  if (filters.dateFrom) params.set('dateFrom', filters.dateFrom);
  if (filters.dateTo) params.set('dateTo', filters.dateTo);
  if (filters.q) params.set('q', filters.q);
  if (filters.weightFrom !== undefined) params.set('weightFrom', String(filters.weightFrom));
  if (filters.weightTo !== undefined) params.set('weightTo', String(filters.weightTo));
  if (filters.volumeFrom !== undefined) params.set('volumeFrom', String(filters.volumeFrom));
  if (filters.volumeTo !== undefined) params.set('volumeTo', String(filters.volumeTo));
  if (filters.managerId && filters.managerId.length > 0) {
    for (const id of filters.managerId) params.append('managerId', id);
  }
  // WHY (#583): `unread` is a chip-active flag. Serialize ONLY when the
  // chip is on; never emit `unread=false`. The backend treats absent
  // and `false` identically; the canonical wire shape keeps URLs minimal
  // and avoids implying an inverse "only read" filter exists.
  if (filters.unread === true) params.set('unread', 'true');
  // WHY (#1054): kind scalar — single-select; absent = both kinds.
  if (filters.kind) params.set('kind', filters.kind);
  if (filters.cursor) params.set('cursor', filters.cursor);
  // WHY: emit `limit` only when it differs from the schema default (50) so a
  // shared bookmark URL stays minimal. The schema fills the default on the
  // receive side regardless.
  if (filters.limit !== undefined && filters.limit !== 50) {
    params.set('limit', String(filters.limit));
  }
  return params.toString();
}
